import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TarjetasService, consultaAbtResp, movements } from '../../service/tarjetas.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { PerfilService } from 'src/app/service/perfil.service';
import { VerifiCard } from '../../VerifiCard';
import * as moment from 'moment'
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-resumen',
  templateUrl: './resumen.component.html',
})

export class ResumenComponent implements OnInit {
  dni: any;
  cards: any;
  user: any;
  noCards = false;
  result = false;
  dataRes = {
    card: { numTarjeta: 0 }
  };
  mandatos: any;
  ra: any;
  carga = false;
  valid = true
  session: any;
  cardNumber: any;
  cardName: any;
  cardDate: any;
  cardMonto: any;
  cardCVV: any;
  cardCuotas = '';
  realNumerCard: any;
  cardCompro: any
  nTarjeta: any;
  response: any;
  nuevaSolicitud = false;
  paso2 = false;
  titulo_modal: any;
  modal_title = "Afiliar tarjeta";
  nomTarjeta: any;
  desclas: any;
  codSubClass: any;
  numTarjetExt: any;
  cardDateReal: any;
  errorMensaje: any;
  newCard = false
  tipoClasif: any;
  clasif: any;
  bloqueo = '-1';
  codeClass: any;
  nombres: any;
  apePaterno: any;
  apeMaterno: any;
  apeCasada: any;
  email: any;
  tel: any;
  monto: any;
  desc: any;
  tipo: any
  sexo: any;
  totalCards: any
  modalError: any
  soliciExito: any
  loading = false;
  errorMonto: any;
  errorMonto2: any;
  error: any;
  date: any;
  hora: any;
  FormatDate: any;
  fechNaci: string;
  validate = new VerifiCard;
  fechaAux = new Date()
  pinTarjeta: any;
  errorSolicitud: boolean;
  clasificaciones: any;
  errorFVTC: boolean;
  msjFVTC: string;
  transacciones: Subscription;
  gettingData: boolean = false;

  resume: consultaAbtResp = {
    estadoVigencia: null,
    mensaje: "Numero Interno Cuenta TNE incorrecto",
    saldo: null,
    listaTransacciones: []
  };

  cargaList: movements[] = [];
  viajeList: movements[] = [];

  tituloSolicitud: string = '';
  constructor(private tarjetas: TarjetasService, private route: Router, private login: LoginService, private perfil: PerfilService) {

    //this.login.currentSession.subscribe(login => this.session = login);

    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi
  }


  loadPerfil() {
    let json = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario
    }
    this.perfil.loadUser(json).subscribe(res => {
      this.response = res;
      this.nombres = this.response.nombres;
      this.apePaterno = this.response.apePaterno;
      this.apeMaterno = this.response.apeMaterno;
      this.sexo = this.response.sexo;
      this.email = this.response.correo;
      this.tel = this.response.telefono;
      this.fechNaci = `${this.response.fecNacimiento.day}/${this.response.fecNacimiento.month}/${this.response.fecNacimiento.year}`

    })
  }

  ngOnInit() {

  }
  loaderOff($event) {
    this.dataRes = $event
    this.getData()
    this.noCards = false;
    this.loading = false
  }

  countDots(monto) {
    let cuenta = 0;
    let posicion = monto.indexOf(".");
    if (monto.indexOf(".") == 0 || monto.indexOf(".") == monto.length - 1) return true
    while (posicion != -1) {
      cuenta++;
      posicion = monto.indexOf(".", posicion + 1);
    }
    if (cuenta > 1) return true;
    else return false;
  }


  deFormat() {
    this.cardNumber = this.cardNumber.split(' ').join('');
  }
  formatDate() {
    this.cardDateReal = this.cardDate
    var test = this.cardDate.match(/.{1,2}/g)
    this.cardDate = '';
    this.cardDate = test[0];
    this.cardDate += '/';
    if (test[1]) {
      this.cardDate += test[1]
    }
  }

  deformatDate() {
    this.cardDate = this.cardDate.split('/').join('')
  }


  addNewCard() {
    this.loading = true
    if (this.nTarjeta != undefined) {
      if (this.validate.verificar(this.nTarjeta, this.pinTarjeta)) {
        let json = {
          KSI: this.session.idSession,
          idUsuarioWeb: this.session.usuarioWeb,
          indFavorita: "N",
          numTarjeta: this.nTarjeta,
          etiqueta: this.nomTarjeta
        }
        let jsons = {
          KSI: this.session.idSession,
          idUsuarioWeb: this.session.usuarioWeb
        }

        this.tarjetas.newCard(json).subscribe(res => {
          if (res.numError == 0) {
            this.tarjetas.getCards(jsons).subscribe(res => {
              this.tarjetas.addCards(res.resumen)
              this.closeModal();
              this.newCard = true;
              this.loading = false;
            })
          } else {
            this.loading = false;
            this.modalError = res.msjError
          }
        }, () => {
          this.loading = false;
          this.modalError = "Error al afiliar tarjeta. Inténtelo más tarde.";
        })
      } else {
        this.loading = false;
        this.modalError = "Número de tarjeta inválido"
      }
    } else {
      this.loading = false;
      this.modalError = "Debe Ingresar un número de tarjeta"
    }
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }

  onlyNumber2($event) {
    this.errorMonto = false;
    let key = $event.charCode;
    if (key <= 57 && key >= 48 || key == 46) {
      this.validateMonto();
      return true;
    } else {
      return false
    }
  }

  onlyLetter(event) {
    let especiales = [225, 233, 237, 243, 250, 193, 201, 205, 211, 218, 228, 235, 239, 246, 252, 196, 203, 207, 214, 220]
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || especiales.includes(event.keyCode)) {
      return true
    }
    else {
      return false
    }
  }

  comproboDate() {
    var fecha = new Date(this.date)
    var today = new Date();
    let errorFecha = false;
    today.setHours(0, 0, 0, 0)
    errorFecha = (fecha >= today)
    return errorFecha
  }

  separateMovements(movements: movements[]) {
    this.cargaList = []
    this.viajeList = []
    movements.forEach(item => {
      if (item.MONTO_ABONO != 0) {
        this.cargaList.push(item)
      } else {
        this.viajeList.push(item)
      }
    })
  }

  validateMonto() {
    if (this.countDots(this.cardMonto) || this.cardMonto == '.') this.errorMonto2 = true;
    else this.errorMonto2 = false;
  }
  comprobante() {
    this.modal_title = "Comprobante de Compra"
    this.carga = false
    this.result = true

  }
  comproboEmail() {
    let mailValido = false;
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.email.match(EMAIL_REGEX)) {
      mailValido = true;
    }
    return mailValido;
  }

  solicitud(response: boolean) {
    this.nuevaSolicitud = response
  }


  closeModal() {
    this.error = false
    this.result = false;
    this.carga = false;
    this.noCards = false;
    this.soliciExito = false;
    this.cardCVV = '';
    this.cardCuotas = '';
    this.cardNumber = '';
    this.cardDate = '';
    this.cardName = '';
    this.validaFechaTC();
    this.valid = true;

    this.cardMonto = '';
  }

  getData() {
    let date = new Date()
    let dateFormat = `${date.getFullYear()}/${("0" + date.getMonth()).slice(-2)}/${("0" + date.getDay()).slice(-2)}`;
    let json = {
      "tipoConsulta": 2,
      "numExterno": this.dataRes.card.numTarjeta,
      "numInterno": localStorage.getItem("numInt"),
      "numeroDias": 10,
      "nivelConsulta": 2
    }
    if (!this.gettingData) {
      this.gettingData = true
      this.transacciones = this.tarjetas.getTransaccionesAbt(json).pipe(take(1)).subscribe(
        (res: consultaAbtResp) => {
          this.resume = res;
          this.gettingData = false
          this.separateMovements(this.resume.listaTransacciones);
        })
    }

  }

  comproboTrx(data) {
    if (data.codigotipotrx != 15) {
      return data.estacion
    }

    if (data.servicio == null) {
      return data.estacion
    }

    return data.servicio


  }

  validaFechaTC() {
    this.errorFVTC = false;
    const x = moment()
    const aux = moment(this.cardDate, 'MMYY');
    const month = new Date().getMonth() + 1
    const year = new Date().getFullYear().toString().substring(2)

    if (this.cardDate.substr(0, 2) <= 12) {
      if (month + year == this.cardDate) this.errorFVTC = false;
      else {
        this.errorFVTC = moment(aux).isBefore(x)
        this.msjFVTC = "Fecha no puede ser menor a la actual."
      }
    }
    else {
      this.errorFVTC = true;
      this.msjFVTC = "No existe mes " + (this.cardDate.substr(0, 2)) + "."
    }
  }


  ngOnDestroy() {
    if (this.transacciones) {
      this.transacciones.unsubscribe();
    }
  }

}
